{
 "CRC 1.35(a)": {
  "text": "Judicial Council forms approved for optional use may be used by parties, and every court must accept them for filing.",
  "document": "28_california_rules_of_court_title-1-rules-applicable-to-all-courts-pdf"
 },
 "CRC 2.100-2.119": {
  "text": "Papers filed in a trial court follow the format rules: paper, type, spacing, margins, line and page numbering, the first page, and the separate statement of causes of action and defenses.",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 2.111": {
  "text": "The first page of each paper has, in set places, the filer's name, address and contact details, a space for the clerk, the court's title, the case title and number, the nature of the paper and, where they apply, the judge and department, the referee, the amount demanded and the words \"Limited Civil Case\".",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 2.111(4)": {
  "text": "Below the court's title is the case title. On an initial complaint or cross-complaint each party's name starts on its own line; on any later paper a short title will do: the first party on each side, with an indication of the others, and a note that a cross-action is involved if one is.",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 2.111(6)": {
  "text": "Below the case number goes the nature of the paper (and on a complaint or petition, the character of the action). In a case with multiple parties, an answer, response or opposition must identify the party whose complaint, motion or other matter it answers or opposes, and which one.",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 2.111(10)": {
  "text": "The caption of every pleading and other paper filed in a limited civil case has the words \"Limited Civil Case\".",
  "applies": "limited",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 2.112": {
  "text": "Each separately stated cause of action, count or defense states its number, its nature, the party asserting it if the pleading is for more than one party, and the parties it is directed to.",
  "document": "50_crc_title-2-trial-court-rules-full.pdf"
 },
 "CRC 3.110(c)": {
  "text": "A cross-complaint against a party who has appeared must be filed with proof of service. If it adds new parties, it must be served on all parties, and proofs of service on the new parties filed within 30 days of filing it.",
  "applies": "not ud and not collections",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.110(d)": {
  "text": "The parties may agree, without leave of court, to one 15-day extension of the 30 days to respond to the initial complaint.",
  "applies": "not ud and not collections",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.110(e)": {
  "text": "The court may extend or modify the times for service and response, on its own motion or on a party's application. An application to extend the time to serve a pleading must be filed before the time has run, with a declaration explaining why service isn't complete.",
  "applies": "not ud and not collections",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.110(g)": {
  "text": "If a responsive pleading isn't served in time and no extension was granted, the plaintiff must file a request for entry of default within 10 days after the time has run.",
  "applies": "not ud and not collections",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.221(c)": {
  "text": "In a general civil case the plaintiff serves the court's ADR information package on each defendant with the complaint, and a cross-complainant serves it on any new parties with the cross-complaint.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.222": {
  "text": "A cross-complainant must serve the complaint (or the most recently amended one) and any answers to it on cross-defendants who haven't appeared.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.402": {
  "text": "A defendant may file and serve, no later than its first appearance, a counter Civil Case Cover Sheet (CM-010) designating the action as complex or as not complex, or join the plaintiff's complex designation. The court decides within 30 days.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.724": {
  "text": "Unless the court sets another time, the parties must meet and confer no later than 30 calendar days before the initial case management conference, on the issues rule 3.727 lists and others the rule names.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.725(a)": {
  "text": "Each party must file and serve a case management statement no later than 15 calendar days before the case management conference or review.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "CRC 3.725(c)": {
  "text": "The case management statement is on the mandatory form CM-110, with every applicable item completed.",
  "document": "51_crc_title-3-civil-rules-full"
 },
 "Fee Schedule item 5": {
  "text": "Answer or other first paper filed by each party other than the plaintiff in an unlimited civil case (including unlawful detainer): $435, more in counties with a local courthouse construction surcharge.",
  "applies": "cls = unlimited",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "Fee Schedule item 9": {
  "text": "Answer or other first paper filed by each party other than the plaintiff in a limited civil case over $10,000 up to $35,000 (including unlawful detainer): $370, more in counties with a local surcharge.",
  "applies": "cls = limitedOver10k",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "Fee Schedule item 12": {
  "text": "Answer or other first paper filed by each party other than the plaintiff in a limited civil case up to $10,000 (including unlawful detainer): $225, more in counties with a local surcharge.",
  "applies": "cls = limitedUpTo10k",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "Fee Schedule item 14": {
  "text": "Cross-complaint raising the amount at issue from $10,000 or less to more than $10,000 (not over $25,000): $145, more in counties with a local surcharge.",
  "applies": "cls = limitedUpTo10k",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "Fee Schedule item 15": {
  "text": "Amended complaint or cross-complaint that reclassifies the case from limited to unlimited civil: $140.",
  "applies": "limited",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "Fee Schedule item 22": {
  "text": "Complex case fee for each defendant: $1,000, the defendants together paying no more than $18,000.",
  "document": "61_sf_statewide-civil-fee-schedule-eff-2026-01-01"
 },
 "CCP 92(b)": {
  "text": "Under the economic litigation rules for limited civil cases, the answer need not be verified, even if the complaint or cross-complaint is.",
  "applies": "limited and not ud",
  "document": "64_ccp_part-1_title-1"
 },
 "CCP 93(b)": {
  "text": "Under the economic litigation rules for limited civil cases, a defendant served with a case questionnaire serves its completed defendant's case questionnaire on the plaintiff with the answer.",
  "applies": "limited and not ud",
  "document": "64_ccp_part-1_title-1"
 },
 "CCP 128.7(a)": {
  "text": "Every pleading, petition, notice of motion or similar paper is signed by at least one attorney of record in the attorney's own name, or by the party if not represented, and states the signer's address and telephone number. An unsigned paper is stricken unless the omission is corrected promptly.",
  "document": "64_ccp_part-1_title-1"
 },
 "CCP 128.7(b)": {
  "text": "Presenting a paper to the court certifies, after reasonable inquiry, that it isn't for an improper purpose, that its claims and defenses are warranted by law, and that its factual allegations and denials have or are likely to have evidentiary support.",
  "document": "64_ccp_part-1_title-1"
 },
 "CCP 403.060": {
  "text": "Reclassifying a case from limited to unlimited civil costs the fee in GC 70619, on top of the other fees for that filing; without it the clerk doesn't reclassify the case. Reclassifying from unlimited to limited has no fee.",
  "applies": "limited",
  "document": "72_ccp_part-2_title-4"
 },
 "CCP 412.20(a)(3)": {
  "text": "The summons directs the defendant to file a written pleading in response to the complaint within 30 days after the summons is served.",
  "document": "74_ccp_part-2_title-5"
 },
 "CCP 422.30(b)": {
  "text": "In a limited civil case the caption states that it is a limited civil case.",
  "applies": "limited",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 422.40": {
  "text": "The title of the action in the complaint names all the parties; in other pleadings the first party on each side, with an indication of the others, is enough.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 425.12(a)": {
  "text": "The Judicial Council develops and approves official forms for complaints, cross-complaints and answers in actions for personal injury, property damage, wrongful death, unlawful detainer, breach of contract and fraud.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 428.10(a)": {
  "text": "A party sued in a complaint or cross-complaint may cross-complain against any party who filed the complaint or cross-complaint against it.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 428.40": {
  "text": "A cross-complaint is a separate document.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 428.50(a)": {
  "text": "A cross-complaint against a party who sued the cross-complainant is filed before or at the same time as the answer.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 428.50(c)": {
  "text": "A cross-complaint filed outside the times in subdivisions (a) and (b) needs leave of court, which may be granted in the interest of justice at any time.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 428.60": {
  "text": "A cross-complaint is served on a party who hasn't appeared with a summons, as an original action is, and on a party who has appeared through its attorney (or itself, if it appeared without one).",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 430.40(b)": {
  "text": "A party who filed a complaint or cross-complaint may demur to the answer within 10 days after it is served.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 430.80(a)": {
  "text": "A party that doesn't object to a complaint or cross-complaint by demurrer or answer waives the objection, except that the court has no jurisdiction of the subject of the cause of action or that the pleading doesn't state facts sufficient to constitute a cause of action.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.20(a)": {
  "text": "Every material allegation of a complaint or cross-complaint that the answer doesn't controvert is taken as true.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(b)(1)": {
  "text": "The answer contains the general or specific denial of the material allegations the defendant controverts.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(b)(2)": {
  "text": "The answer contains a statement of any new matter constituting a defense.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(c)": {
  "text": "Affirmative relief may not be claimed in the answer.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(d)": {
  "text": "A general denial is enough if the complaint is unverified or the case is under the economic litigation rules (CCP 90 et seq.), but it only puts the material allegations in issue. Against a verified complaint in any other case the denials must be positive or on information and belief, and so they must in any case where the claim was assigned to a third party for collection.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(e)": {
  "text": "A defendant without information or belief enough to answer an allegation may say so and deny it on that ground.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(f)": {
  "text": "Denials may refer to specific paragraphs or parts of the complaint, or expressly admit some allegations and generally deny the rest, or deny some on information and belief or for lack of it and generally deny the rest.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 431.30(g)": {
  "text": "Defenses are separately stated and refer to the causes of action they answer, so they can be told apart.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 432.10": {
  "text": "A party served with a cross-complaint may move, demur or otherwise plead to it within 30 days after service, as to an original complaint.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 446(a)": {
  "text": "Every pleading is subscribed by the party or its attorney. When the complaint is verified, the answer is verified, except that a public entity or officer sued in an official capacity need not verify. The party verifies; an officer may verify for a corporation, and the attorney or another person may verify when the parties are absent from the county or otherwise unable to, or the facts are within that person's knowledge, stating why.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 458": {
  "text": "A statute of limitations defense can be pleaded generally, by stating that the cause of action is barred by a named section (and subdivision) of the Code of Civil Procedure; if it is controverted, the facts are proved at trial.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 465": {
  "text": "Pleadings after the complaint are filed with the clerk or judge, with proof of service unless a summons must issue, and copies are served on the adverse party or its attorney.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 471.5(a)": {
  "text": "If the complaint is amended, the amendments or amended complaint are filed and served on the defendants affected, who answer within 30 days after service or other time the court directs; otherwise default may be entered.",
  "document": "75_ccp_part-2_title-6"
 },
 "CCP 631(b)": {
  "text": "At least one party demanding a jury on each side pays a nonrefundable $150 jury fee, unless another party on the same side has paid it.",
  "document": "78_ccp_part-2_title-8"
 },
 "CCP 631(c)(1)": {
  "text": "In an unlawful detainer the jury fee is due at least five days before the date set for trial.",
  "applies": "ud",
  "document": "78_ccp_part-2_title-8"
 },
 "CCP 631(c)(2)": {
  "text": "If no case management conference is scheduled, the jury fee is due no later than 365 calendar days after the initial complaint was filed.",
  "document": "78_ccp_part-2_title-8"
 },
 "CCP 631(c)(4)": {
  "text": "If the party requesting a jury hadn't appeared before the initial case management conference, or first appeared more than 365 calendar days after the initial complaint was filed, the jury fee is due at least 25 calendar days before the date first set for trial.",
  "document": "78_ccp_part-2_title-8"
 },
 "CCP 1167(a)": {
  "text": "In an unlawful detainer the defendant's response is due within 10 days after the complaint is served, excluding Saturdays, Sundays and judicial holidays.",
  "applies": "ud",
  "document": "90_ccp_part-3_title-3"
 },
 "CCP 1281.2": {
  "text": "On a party's petition, the court orders arbitration of a controversy under a written agreement to arbitrate, unless the right was waived, grounds exist to rescind the agreement, or another exception in the section applies.",
  "document": "95_ccp_part-3_title-9"
 },
 "CCP 1281.7": {
  "text": "A petition to compel arbitration under CCP 1281.2 may be filed instead of an answer. If it is denied, the defendant has 15 days after the denial to plead to the complaint.",
  "document": "95_ccp_part-3_title-9"
 },
 "GC 70612": {
  "text": "The uniform fee for the first paper of a defendant or other adverse party in an unlimited civil case, whether filing separately or jointly.",
  "applies": "cls = unlimited",
  "document": "171_gov_title-8"
 },
 "GC 70613.5(b)": {
  "text": "A party who paid the first paper fee under GC 70614(b) and then files a cross-complaint demanding more than $10,000 but not more than $25,000 pays the difference between that fee and the fee under GC 70614(a).",
  "applies": "cls = limitedUpTo10k",
  "document": "171_gov_title-8"
 },
 "GC 70614(a)": {
  "text": "The uniform fee for the first paper of a party other than a plaintiff in a limited civil case.",
  "applies": "cls = limitedOver10k",
  "document": "171_gov_title-8"
 },
 "GC 70614(b)": {
  "text": "The lower uniform fee for the first paper of a party other than a plaintiff in a limited civil case demanding $10,000 or less.",
  "applies": "cls = limitedUpTo10k",
  "document": "171_gov_title-8"
 },
 "GC 70616(b)": {
  "text": "Each defendant or other adverse party pays a complex case fee with its first paper if the case is designated or counterdesignated complex, or when the court determines it is complex; the defendants' total is capped.",
  "document": "171_gov_title-8"
 },
 "GC 70619": {
  "text": "The fee for reclassifying a case from limited to unlimited civil under CCP 403.060 is $140.",
  "applies": "limited",
  "document": "171_gov_title-8"
 }
}
